module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI2N2FhMGQ0YWI5Y2I0MzVmZWNjMDljY2U2OGE5MWFmMi5zdmciOw=="